import { takeLatest, put, all, call } from 'redux-saga/effects';

import BranchDCBReportActionTypes from './branch-DCB-report.types';

import { branchDCBReportListGet } from './branch-DCB-report.service';

import {
	getBranchDCBReportDetailsSuccess,
	getBranchDCBReportDetailsFailure,
	getBranchDCBReportDetailsResponseChanged,
} from './branch-DCB-report.action';

import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET BRANCH DCB REPORT DETAILS  ******************** */
export function* getBranchDCBReportList({ payload }: any) {
	try {
		const key = 'GetBranchDCBReportKey';
		const {
			companyID,
			databaseName,
			fromDate,
			toDate,
			branchID,
			centerID,
			groupID,
			funderID,
			isBusiness,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			IsBusiness: isBusiness,
			LoanFunder: funderID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(branchDCBReportListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchDCBReportDetailsFailure(responseData.data));
		} else {
			yield put(getBranchDCBReportDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchDCBReportDetailsFailure(error));
	}
}

export function* resetgetBranchDCBReportListResponse() {
	yield put(getBranchDCBReportDetailsResponseChanged());
}

export function* onGetBranchDCBReportListDetails() {
	yield takeLatest(
		BranchDCBReportActionTypes.GET_BRANCH_DCB_REPORT_LIST_START,
		getBranchDCBReportList,
	);
}

export function* onGetBranchDCBReportListResponseReset() {
	yield takeLatest(
		BranchDCBReportActionTypes.GET_BRANCH_DCB_REPORT_LIST_RESPONSE_RESET,
		resetgetBranchDCBReportListResponse,
	);
}
/** *********************  END GET BRANCH DCB REPORT DETAILS ******************** */

export function* branchDCBReportSaga() {
	yield all([call(onGetBranchDCBReportListDetails), call(onGetBranchDCBReportListResponseReset)]);
}
